var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"divLinkageClass"},[_c('el-cascader',{ref:"derLinkageClass",staticClass:"width_100Pie",class:_vm.comClass,attrs:{"options":_vm.optClass,"placeholder":_vm.comPlaceholder,"props":{
      expandTrigger: 'hover',
      checkStrictly: _vm.comCheckStrictly,
      multiple: _vm.comMultiple,
    },"collapse-tags":_vm.comMultiple,"filterable":""},on:{"change":_vm.handleChange},model:{value:(_vm.classIds),callback:function ($$v) {_vm.classIds=$$v},expression:"classIds"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }